import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";

import { currentRolesSelector } from "../../redux/slices/auth/selectors";
import { isUserAdmin, isUserSuperAdmin } from "../../utils/role";
import { useAuth } from "../hooks";
import useRedirectState from "../hooks/useRedirectStats";

type AppRouteProps = RouteProps & {
    auth?: boolean;
};

const AppRoute = ({ auth, ...restProps }: AppRouteProps): JSX.Element => {
    const { isLoggedIn, currentUser } = useAuth();
    const currentRoles = useSelector(currentRolesSelector);
    const { canRedirect } = useRedirectState();
    const location = useLocation();
    const isRedirectURL = canRedirect && location.pathname !== "/";
    if (auth) {
        if (currentUser && isLoggedIn) {
            return <Route {...restProps} />;
        } else {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        search: isRedirectURL
                            ? `?redirectURL=${location.pathname}`
                            : "",
                        state: { from: canRedirect ? location : null },
                    }}
                />
            );
        }
    } else {
        if (currentUser && isLoggedIn) {
            if (isUserAdmin(currentRoles) || isUserSuperAdmin(currentRoles)) {
                return <Redirect to="/user-management" />;
            } else {
                return <Redirect to="/project" />;
            }
        } else {
            return <Route {...restProps} />;
        }
    }
};

export default AppRoute;
